<template>
  <div class="modal_mask" @click="toggleModalCurrencies()">
    <div class="wrapper_modal_other_currencies">
      <div class="content_other_currencies">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          @click="toggleModalCurrencies()"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        <div class="title_other_currencies" style="text-align: center" v-if="selectedCurrency.currency.symbol == 'TUSD'">
          Tether (USDT)
        </div>
        <div class="title_other_currencies" style="text-align: center" v-else>
          {{ selectedCurrency.currency.name }} ({{
            selectedCurrency.currency.symbol
          }})
        </div>
        <div class="currencies_equivalent">
          <!-- <h2>{{ $t("msg.price") }}: {{selectedCurrency.currency}}</h2> -->

          <div class="wrapper_currencies_list" style="margin-top: 20px">
            <span
              class="currencies_icon background_ icon_class_10 val_m"
              :class="'background_' + selectedCurrency.currency.symbol"
            ></span>
          </div>

          <p>{{ $t(`msg.text_${selectedCurrency.currency.symbol}`) }}</p>
          <p v-if="selectedCurrency.apy">
            Staking APY:
            <span style="color: #3ed18f; font-weight: 600;"> <span v-if="selectedCurrency.apy > 0">+</span>{{ selectedCurrency.apy }}%</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["type", "selectedCurrency"],
  created() {
    this.checkCurrencis();

    this.checkType();
  },
  data: () => ({
    pairs: [],
    pairSymbs: ["BTC", "ETH", "USD", "BRL", "GBP", "ZAR", "EUR"],
    blue: {},
    fundTails: {},
  }),
  methods: {
    toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },

    async checkType() {
      console.log(this.type);

      if (this.type == "supply") {
        this.getFundTails();
      }
    },

    async getFundTails() {
      let params = {
        offset: 0,
        limit: 1,
        entryType: "live",
      };
      try {
        let resp = await this.$store.dispatch("getFundTails", params);
        this.fundTails = resp.data;
      } catch (e) {
        console.log("error ", e);
      }
    },

    checkCurrencis() {
      for (let i in this.currencies) {
        if (this.currencies[i].symbol == "BLU") {
          this.blue = this.currencies[i];
        }
      }

      this.currencies.find((el) => {
        for (let i in this.pairSymbs) {
          if (el.symbol == this.pairSymbs[i]) {
            this.pairs.push(el);
          }
        }
      });

      const fromIndexEther = 3;
      const toIndexEther = 1;

      const elementEther = this.pairs.splice(fromIndexEther, 1)[0];

      this.pairs.splice(toIndexEther, 0, elementEther);
    },

    currencyFormat(num, symb) {
      if (num) {
        if (
          symb == "RAS" ||
          symb == "USDT" ||
          symb == "BRL" ||
          symb == "EUR" ||
          symb == "ZAR" ||
          symb == "GBP"
        ) {
          return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        } else {
          return num.toFixed(8);
        }
      } else {
        return 0;
      }
    },
  },
  computed: {
    ...mapGetters(["eurValue", "currencies", "bluAccount"]),
  },
};
</script>


<style lang="scss" scope>
.modal_mask {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
  overflow: auto;
}

.wrapper_modal_other_currencies {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .content_other_currencies {
    position: relative;
    padding: 2rem 2.5rem;
    border-radius: 6px;
    max-width: 585px;
    max-height: 465px;
    width: 100%;
    background-color: #fff;

    .title_other_currencies {
      display: flex;
      border-bottom: 1px solid black !important;
      padding-bottom: 0.5rem;
      width: 100%;
      font-size: 1.5rem;
      text-align: center;
      justify-content: center;

      h1 {
        font-size: 1rem;
        font-weight: 600;
        color: #342365;
      }

      .usdt_value {
        display: flex;
        align-items: center;
        img {
          width: 1.4rem;
          margin-right: 10px;
        }

        span {
          font-size: 1rem;
          font-weight: 600;
        }
      }
    }

    svg {
      position: absolute;
      top: 0.5rem;
      width: 1.2rem;
      right: 0.5rem;
      cursor: pointer;

      &:hover {
        color: #342365;
      }
    }

    .currencies_equivalent {
      display: flex;
      flex-direction: column;
      align-items: center;

      h2 {
        font-size: 1rem;
        font-weight: 600;
        margin: 1.2rem 0;
      }

      .wrapper_currencies_list {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .currencies_list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.8rem;

          span {
            font-size: 1rem;
            font-weight: 600;
          }

          img {
            width: 1.4rem;
            margin-left: 15px;
          }

          .currencies_icon {
            width: 1.4rem;
            height: 1.4rem;
            margin-left: 15px;
          }
        }
      }

      p {
        margin-top: 0.5rem;
      }

      p:last-child {
        margin-top: 1rem;
      }
    }
  }
}

@media only screen and (max-width: 900px) {
  .wrapper_modal_other_currencies {
    .content_other_currencies {
      padding: 2rem 1.5rem;
      max-width: 350px;
      max-height: 450px;
    }
  }
}

@media only screen and (max-width: 350px) {
  .wrapper_modal_other_currencies {
    .content_other_currencies {
      max-width: 300px;
      max-height: 450px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalCurrencyInfo.vue